import type { Config } from 'plotly.js'
import type { PlotlySizeDefaults } from './types'

/** Shared Plotly runtime options used across charts. */
export const plotlyConfig: Partial<Config> = {
  displayModeBar: false,
  responsive: true,
}

export const plotlyTransparentBg = {
  paper_bgcolor: 'transparent' as const,
  plot_bgcolor: 'transparent' as const,
}

export const plotlyFontSizes: PlotlySizeDefaults = {
  titleFontSize: 12,
  axisTitleFontSize: 10,
  tickFontSize: 10,
  legendFontSize: 10,
}
